import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=792d8010&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d8010",
  null
  
)

export default component.exports